import * as regionConfig from '@pro/common/consts/region-config';

/**
 * 根据国家或区域索引返回大区域名
 */
export function getURLByIndex(index: number) {
  if (regionConfig.REGION_EU.indexOf(index) !== -1) {
    return regionConfig.REGION_HREF.EU;
  }
  if (regionConfig.REGION_SA.indexOf(index) !== -1) {
    return regionConfig.REGION_HREF.SA;
  }
  if (regionConfig.REGION_SGP.indexOf(index) !== -1) {
    return regionConfig.REGION_HREF.SGP;
  }
  if (regionConfig.REGION_US.indexOf(index) !== -1) {
    return regionConfig.REGION_HREF.US;
  }
  if (regionConfig.REGION_RU.indexOf(index) !== -1) {
    return regionConfig.REGION_HREF.RU;
  }
  if (regionConfig.REGION_IN.indexOf(index) !== -1) {
    return regionConfig.REGION_HREF.IN;
  }
}

export default getURLByIndex;
